/* global StampedFn, jQuery */

import React from 'react';
import config from 'sharedConfig';

class ProductRatings extends React.Component {
  constructor(props) {
    super(props);
    this._loadRatingsMeta = this._loadRatingsMeta.bind(this);
    this.state = { prerender: typeof window === 'undefined' };
    this.jQueryAttempts = 0;
    this.jQueryAttemptInterval = 200;
    this.jQueryMaxAttempts = 50;
  }

  componentDidMount() {
    if (this.props.product.sku_id) this._loadStamped();
    this._listenForStampedEvents();
  }

  componentDidUpdate(prevProps) {
    const sku = this.props.product.sku_id;
    const prevSku = prevProps.product.sku_id;
    if (sku && sku !== prevSku) {
      this._loadStamped();
    }
  }

  componentWillUnmount() {
    this._teardownStamped();
  }

  _loadStamped() {
    if (!this.stampedInitialized) {
      StampedFn.init({
        apiKey: config.stamped.apiKey,
        storeUrl: config.stamped.storeUrl
      });
      this.stampedInitialized = true;
    }

    if (!window.jQuery && this.jQueryAttempts < this.jQueryMaxAttempts) {
      return setTimeout(() => this._loadStamped(), this.jQueryAttemptInterval);
    }

    if (window.StampedFn && this.widget) {
      this.widget.innerHTML = '';
      StampedFn.loadWidget();
    }
  }

  _teardownStamped() {
    if (window.jQuery)
      jQuery(document).off('stamped:reviews:loaded', this._loadRatingsMeta);
  }

  _listenForStampedEvents() {
    if (!window.jQuery && this.jQueryAttempts < this.jQueryMaxAttempts) {
      return setTimeout(
        () => this._listenForStampedEvents(),
        this.jQueryAttemptInterval
      );
    }

    jQuery(document).on('stamped:reviews:loaded', this._loadRatingsMeta);
  }

  _loadRatingsMeta() {
    const getContent = selector => {
      const el = document.querySelector(selector);
      const content = el && el.getAttribute('content');
      if (content) return Number(content);
    };
    const ratingCount = getContent('meta[itemprop="ratingCount"]');
    const ratingValue = getContent('meta[itemprop="ratingValue"]');
    this.props.onRatingsLoaded({ ratingCount, ratingValue });
  }

  render() {
    const product = this.props.product;
    const ratings = this.props.ratings || {};
    const { prerender } = this.state;

    return prerender ? (
      <div
        id="stamped-main-widget"
        data-rich-snippet="false"
        data-product-id={product._id}
        data-name={product.title}
        data-url={product.url ? config.site.url + product.url : null}
        data-image-url={product.image}
        data-description={product.description}
        data-product-sku={product.sku_id}
        data-take-reviews={6}
      >
        {prerender &&
          ratings.product && (
            <div
              className="stamped-header"
              dangerouslySetInnerHTML={{ __html: ratings.product }}
            />
          )}
        {prerender &&
          ratings.widget && (
            <div
              className="stamped-content"
              dangerouslySetInnerHTML={{ __html: ratings.widget }}
            />
          )}
      </div>
    ) : (
      <div
        ref={div => (this.widget = div)}
        id="stamped-main-widget"
        data-rich-snippet="false"
        data-product-id={product._id}
        data-name={product.title}
        data-url={product.url ? config.site.url + product.url : null}
        data-image-url={product.image}
        data-description={product.description}
        data-product-sku={product.sku_id}
        data-take-reviews={6}
      />
    );
  }
}

export default ProductRatings;



// WEBPACK FOOTER //
// ./shared/components/product/ratings.js